import React from 'react';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {SoopInputBox} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';

const UserId = () => {
  const {userId} = useHelpContext();
  const isGuest = !userId;

  return (
    <div className={styles.section}>
      <label className={styles.label}>아이디</label>
      <SoopInputBox
        value={userId || 'guest'}
        clearable={false}
        size={44}
        disabled
        readOnly
      />

      {isGuest && (
        <p className={styles.helperText}>
          로그인이 되지 않았을 경우 guest로 표기됩니다.
        </p>
      )}
    </div>
  );
};

export default UserId;
